function scrollToUp(x = 0, y = 0) {
  window.scrollTo(x, y, { behavior: 'smooth' })
}

export default scrollToUp
